import { Button } from "@/components/base/buttons/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ApplyToAllDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onlyFutureLabel?: string;
  onChoose: (applyToExisting: boolean) => void;
  isPending?: boolean;
}

export function ApplyToAllDialog({
  open,
  onOpenChange,
  onlyFutureLabel = "Only future collaborations",
  onChoose,
  isPending,
}: ApplyToAllDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[544px]">
        <DialogHeader>
          <DialogTitle>Apply to all existing collaborations?</DialogTitle>
          <DialogDescription>
            <span className="block mb-3">
              This will run on all active TikTok collaborations unless they already have a custom automation set.
            </span>
            <span className="block">
              If you're testing other automation tools alongside this, just keep an eye out for duplicate messages.
            </span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button color="secondary" size="md" onClick={() => onChoose(false)} isDisabled={isPending}>
            {onlyFutureLabel}
          </Button>
          <Button color="primary" size="md" onClick={() => onChoose(true)} isLoading={isPending}>
            Turn on for all
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
